import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Section174AdjService {

  constructor(private http: HttpClient) {}

  saveSection174(
    baseUrl: string,
    data: any[],
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=mfnpur`;

    const jsonObj = JSON.stringify(data);
    const jsonSettings = JSON.stringify(data);

    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ jsonObj: jsonObj }, params);
    params = _.extend({ jsonSettings: jsonSettings }, params);
    params.process_name = 'SAVE_SECTION174_DETAILS';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
